/**
 * Created by Timur on 27.07.2026
 */

const BalloonRise = function (mission) {
    cleverapps.EventEmitter.call(this);
    this.mission = mission;
    const data = this.mission && this.mission.details || {};
    this.level = data && data.level || 0;
    this.stage = data && data.stage || 0;
    this.unlocked = data && data.unlocked || false;
    this.stages = this.mission.stages;
    this.regularStagesCount = this.stages.filter((stage) => !stage.extra).length;
    this.countDown = new cleverapps.CountDown(this.getTimeLeft(), {
        permanent: true,
        onFinish: this.onTimeout.bind(this)
    });

    if (this.stage >= this.stages.length) {
        this.mission.complete();
    } else if (this.unlocked && this.getTimeLeft() === 0) {
        this.mission.complete();
    }

    if (this.mission.isRunning()) {
        this.mission.logEvent(Mission.EVENTS.MISSION_STAGE, { itemId: `${this.stage}`, once: true });
    }
};

BalloonRise.prototype = Object.create(cleverapps.EventEmitter.prototype);
BalloonRise.prototype.constructor = BalloonRise;

BalloonRise.prototype.getView = function () {
    return this.unlocked ? BalloonRiseWindow : BalloonRiseStartWindow;
};

BalloonRise.prototype.getFinishWindow = function () {
    return this.unlocked ? BalloonRiseFinishWindow : undefined;
};

BalloonRise.prototype.isUnlocked = function () {
    return this.unlocked;
};

BalloonRise.prototype.startCompetition = function () {
    if (this.unlocked) {
        return;
    }

    this.unlocked = true;
    this.update();
    this.mission.logEvent(Mission.EVENTS.MISSION_UNLOCKED);
};

BalloonRise.prototype.getTimeLeft = function () {
    return this.mission.getTimeLeft();
};

BalloonRise.prototype.showLoseWindow = function () {
    cleverapps.focusManager.display({
        focus: "balloonRiseLose",
        actions: [
            (f) => {
                new BalloonRiseWindow(this.mission);
                cleverapps.focusManager.onceNoWindowsListener = () => {
                    this.needShowLoseWindow = false;
                    this.level = 0;
                    this.stage = this.getCheckpointStage();
                    this.update();
                    cleverapps.missionManager.trigger("balloonRiseLoseProcessed", this.mission);
                    f();
                };
            }
        ]
    });
};

BalloonRise.prototype.onTimeout = function () {
    this.trigger("timeout");

    if (this.unlocked && !this.isAllStagesCompleted()) {
        this.mission.complete();
    }
};

BalloonRise.prototype.isAttentionRequired = function () {
    return this.isStageCompleted();
};

BalloonRise.prototype.isLastStage = function (stage) {
    return stage === this.stages.length - 1;
};

BalloonRise.prototype.getStageRewards = function () {
    return this.stages.map((stage) => this.getStageReward(stage));
};

BalloonRise.prototype.getCurrentReward = function () {
    const stage = this.getCurrentStage();

    return this.getStageReward(stage);
};

BalloonRise.prototype.getStageReward = function (stage) {
    return new RewardsList(stage.prize, {
        event: cleverapps.EVENTS.BALLOON_RISE.EARN,
        toBubbleStack: true
    });
};

BalloonRise.prototype.getCurrentStage = function () {
    return this.getStage(this.stage);
};

BalloonRise.prototype.getStage = function (stage) {
    return this.stages[stage];
};

BalloonRise.prototype.getMaxStage = function () {
    return this.stages.length - 1;
};

BalloonRise.prototype.setLevel = function (level) {
    if (this.level !== level) {
        this.level = level;
        this.trigger("updateLevel");
    }
};

BalloonRise.prototype.updateStage = function () {
    this.level -= this.getCurrentStage().goal;
    this.stage += 1;
    this.mission.logEvent(Mission.EVENTS.MISSION_STAGE, { itemId: `${this.stage}` });

    if (this.stage >= this.stages.length) {
        this.mission.logEvent(Mission.EVENTS.MISSION_FINISH, { once: true });
        this.mission.complete();
    } else {
        this.trigger("updateStage");
        cleverapps.metrics.logEvent(`${cleverapps.EVENTS.BALLOON_RISE.STAGE}${this.stage}`);
    }

    this.update();
};

BalloonRise.prototype.isStageCompleted = function () {
    const stage = this.getCurrentStage();
    if (!stage) {
        return false;
    }

    return this.level >= stage.goal;
};

BalloonRise.prototype.isAllStagesCompleted = function () {
    return this.stage >= this.stages.length;
};

BalloonRise.prototype.isExtraChallenge = function () {
    const stage = this.getCurrentStage();
    return Boolean(stage && stage.extra);
};

// every completed stage is a checkpoint - a loss can only burn progress within the current,
// not yet completed stage, never a stage that was already passed
BalloonRise.prototype.getCheckpointStage = function (stage) {
    return stage === undefined ? this.stage : stage;
};

BalloonRise.prototype.getProgress = function (effective) {
    let stage = this.stage;
    let level = this.level;

    if (effective) {
        while (this.stages[stage] && level >= this.stages[stage].goal) {
            level -= this.stages[stage].goal;
            stage += 1;
        }
    }

    return { stage, level };
};

BalloonRise.prototype.getProgressReward = function (effective) {
    return this.getStageReward(this.getStage(this.getProgress(effective).stage));
};

BalloonRise.prototype.isWin = function () {
    return this.getProgress(true).stage >= this.regularStagesCount;
};

BalloonRise.prototype.incLevel = function (stars) {
    if (!this.unlocked) {
        return;
    }

    this.level += stars;
    this.trigger("updateLevel", true, stars);
    this.update();
};

BalloonRise.prototype.getInfo = function () {
    return {
        level: this.level,
        stage: this.stage,
        unlocked: this.unlocked
    };
};

BalloonRise.prototype.save = function (details) {
    details.level = this.level;
    details.stage = this.stage;
    details.unlocked = this.unlocked;
};

BalloonRise.prototype.update = function () {
    this.mission.update(0, this.getInfo());
    this.updateIcon();
};

BalloonRise.prototype.skipNext = function () {
    return this.isStageCompleted();
};

BalloonRise.prototype.updateIcon = function () {
    this.mission.updateMissionIcon();
    this.trigger("updateStatus");
};

BalloonRise.prototype.onPressed = function () {
    if (this.isStageCompleted()) {
        cleverapps.missionManager.trigger("clickReceiveButton", this.mission.getType());
        return;
    }

    cleverapps.focusManager.display({
        focus: `${this.mission.name}MissionIconClicked`,
        action: function (f) {
            const ViewClass = this.mission.getViewClass();
            new ViewClass(this.mission);
            cleverapps.focusManager.onceNoWindowsListener = f;
        }.bind(this)
    });
};

BalloonRise.prototype.calcStatusInfo = function () {
    const currentStage = this.getCurrentStage();
    if (!currentStage) {
        return;
    }

    const amount = this.level;
    const target = currentStage.goal;

    return {
        text: `%% ${amount}/${target}`,
        icons: {
            "%%": bundles.reward_icons.frames.energy_small_png
        },
        progressBar: { amount, target },
        prize: this.isStageCompleted()
    };
};

BalloonRise.prototype.receiveReward = function () {
    if (!this.isStageCompleted()) {
        return;
    }

    let rewards = {};
    while (this.isStageCompleted()) {
        rewards = RewardsList.sumRewards(rewards, this.getCurrentStage().prize);
        this.updateStage();
    }

    return new RewardsList(rewards, {
        event: cleverapps.EVENTS.BALLOON_RISE.EARN,
        toBubbleStack: true
    });
};

BalloonRise.prototype.canRemove = () => true;
BalloonRise.prototype.canRemoveSilently = function () {
    return !this.unlocked;
};
